var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"fct-button",class:_vm.b_class,attrs:{"tabindex":"-1","type":"button"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }